// Return the array sorting function for its object's properties
export default function capitalizeFirst(string) {
  return string.charAt(0).toUpperCase() + string.substr(1);
}
